/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import RepInfo from "@eisinc/App/Components/RepInfo/RepInfo";
import { infoDisplayStylesTwoV2 } from "@eisinc/App/SharedStyles/InfoDisplayStylesV2";
import { OrderDetailsPageContext } from "@eisinc/Overrides/Pages/OrderDetailsPage";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { FC, useContext } from "react";

const OrderDetailsRepInfo: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    const salesPersonData = order && order.properties && order.properties.salesPerson;

    if (!order || !salesPersonData) {
        return null;
    }

    return <RepInfo salesPersonData={salesPersonData} extendedStyles={infoDisplayStylesTwoV2} />;
};

const widgetModule: WidgetModule = {
    component: OrderDetailsRepInfo,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
